import type { DashboardSettingsResponseDto } from '@api'
import { useUnit } from 'effector-react'
import { useMutation, useQueryClient } from 'react-query'

import { useToast } from '@/components/ui/toast.tsx'
import { $creatorId } from '@/models/creators.ts'
import { rebillMessageService } from '@/modules/creator-settings/rebill-messages/service/rebill-message.ts'
import { useSettingsContext } from '@/modules/creator-settings/state/SettingsProvider.tsx'
import { handleError } from '@/utils/error'

export function useToggleRebillMessageMutation() {
  const toast = useToast()
  const client = useQueryClient()
  const creatorId = useUnit($creatorId)
  const { settingsSortOptions } = useSettingsContext()

  return useMutation(
    (value: boolean) => {
      if (!creatorId) {
        throw new Error('Creator not selected')
      }

      return rebillMessageService.pageToggle(creatorId, value)
    },
    {
      onMutate: (enabled) => {
        client.setQueryData<DashboardSettingsResponseDto | undefined>(
          ['settings', creatorId, settingsSortOptions],
          (state) => {
            if (!state) return state
            toast.success('Settings updated')

            return {
              ...state,
              autoMessageRebilledFansSettings: {
                ...state.autoMessageRebilledFansSettings,
                enabled: enabled,
              },
            }
          },
        )
      },
      onError: (error, value) => {
        handleError(
          error,
          value
            ? 'Failed to enable the message'
            : 'Failed to disable the message',
        )
        client.invalidateQueries(['settings', creatorId, settingsSortOptions])
      },
    },
  )
}
